/**
 * @deprecated — import { apiClient } from '@/api/client' instead.
 *
 * This module is kept for backward compatibility. It re-exports the raw
 * Axios instance from the canonical API client so that existing callers
 * (Settings, UserManagement) continue to work without code changes while
 * benefiting from the shared auth interceptors and token-refresh logic
 * defined in api/client.ts.
 */
import { apiClient } from '@/api/client'

export default apiClient.rawClient
